// Device-level preference: does Enter send the message (the default), or
// insert a newline with sending done by the send button? Haley, 2026-08-29:
// "I keep sending messages with the enter key when I'm trying to make a new
// paragraph… I'm gonna adjust that with Claude so it's the send button
// instead cause I keep doing that haha."
//
// Stored per DEVICE (localStorage, not the profile) on purpose — it is a
// keyboard-feel setting, and one player flipping it must not change the other
// player's muscle memory. Cmd/Ctrl+Enter always sends regardless, so a
// keyboard-first flow survives with the toggle off.
const KEY = 'mfml_enter_sends';

export function enterSendsEnabled() {
  try { return localStorage.getItem(KEY) !== '0'; } catch { return true; }
}

export function setEnterSends(on) {
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* private mode */ }
}

// One test for every composer: send on Enter only when the preference allows
// it, and always on Cmd/Ctrl+Enter. Shift+Enter stays a newline everywhere.
export function enterShouldSend(e) {
  if (e.key !== 'Enter' || e.shiftKey) return false;
  if (e.metaKey || e.ctrlKey) return true;
  return enterSendsEnabled();
}
